import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Helmet from 'react-helmet';
import Container from '../container';
import Subhead from '../subhead';
import RatioImg from '../ratio-img';
import Waves from '../waves';
import Button from '../button';
import RenderMd from '../render-md';

const imageStyles = `
  margin-top: 96px;

  ${screen.below(bp.tablet, `
    margin-top: 72px;
  `)}

  ${screen.below(bp.mobile, `
    margin-top: 50px;
  `)}
`;

const GeneralPage = ({
  pageFields: {
    subheading,
    pageTitle,
    featuredImage,
    pageContent,
    cta,
    useHTML = false,
  },
}) => (
  <main>
    <Helmet title={pageTitle} />
    <Section>
      <Container>

        {!!subheading &&
          <Subhead>{subheading}</Subhead>
        }

        <h1>{pageTitle}</h1>

        {featuredImage && featuredImage.fields && featuredImage.fields.file &&
          <RatioImg
            src={`${featuredImage.fields.file.url}?w=1120&h=670&q=86&fit=thumb&fm=jpg&fl=progressive`}
            width={1120}
            height={670}
            alt={featuredImage.fields.description}
            styles={imageStyles}
          />
        }

        <Content>
          {/* eslint-disable-next-line */}
          {!useHTML ? <RenderMd escapeHtml={useHTML} source={pageContent} /> : <div dangerouslySetInnerHTML={{ __html: pageContent }} /> }

          {!!cta &&
            <ContentButton href={cta.fields.linkUrl}>
              {cta.fields.linkText}
            </ContentButton>
          }

        </Content>
      </Container>

      <Waves
        position="bottom"
        alignment="bottom"
        height={330}
      />
    </Section>
  </main>
);

const Section = styled.section`
  position: relative;
  padding: 290px 0 490px;

  h1 {
    text-align: center;
  }

  ${screen.below(bp.laptop, `
    padding: 220px 0 370px;
  `)}

  ${screen.below(bp.portrait, `
    padding: 150px 0 300px;
  `)}

  ${screen.below(bp.mobile, `
    padding: 150px 0 245px;
  `)}
`;

const Content = styled.div`
  max-width: 910px;
  margin: 110px auto auto;

  p:first-of-type { margin-top: 0; }

  p:last-of-type { margin-bottom: 0; }

  h2,
  h3,
  h4,
  h5,
  h6 {
    & + p:first-of-type { margin-top: 0; }
  }

  p + h2,
  p + h3,
  ul + h2,
  ul + h3 {
    margin-top: 50px;
  }

  p + h4,
  p + h5,
  p + h6,
  ul + h4,
  ul + h5,
  ul + h6 {
    margin-top: 35px;
  }

  ${screen.below(bp.tablet, `
    margin: 82px auto auto;
  `)}

  ${screen.below(bp.mobile, `
    margin: 55px auto auto;
  `)}
`;

const ContentButton = styled(Button)`
  margin-top: 75px;

  ${screen.below(bp.tablet, `
    margin-top: 56px;
  `)}

  ${screen.below(bp.mobile, `
    margin-top: 40px;
  `)}
`;

GeneralPage.propTypes = {
  pageFields: PropTypes.shape({
    subheading: PropTypes.string,
    pageTitle: PropTypes.string.isRequired,
    image: PropTypes.object,
    pageContent: PropTypes.string.isRequired,
    cta: PropTypes.object,
    useHTML: PropTypes.bool,
  }),
};

export default GeneralPage;
